import engine from './engine';

export default {
  getUsers() {
    return engine.get('/users');
  },
  getUserById(id) {
    return engine.get(`/users/${id}`);
  },
};




// WEBPACK FOOTER //
// ./src/service/api-users.js